const FileRoot = 'files';

export const filesPaths = {
  root: FileRoot,
};
